import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogLeftSideBar = () => {
    return (
        <>
            <div className="tw-w-full tw-px-3 lg:tw-w-1/3">
                <div className="blog__sidebar">
                    <div className="sidebar__widget mb-50 ">
                        <div className="sidebar__widget-content">
                            <div className="search">
                                <form action="#">
                                    <label htmlFor="blog-search" className="visually-hidden">Search blog posts</label>
                                    <input id="blog-search" type="text" placeholder="Search..." />
                                    <button type="button" aria-label="Search"><i > <FaSearch /> </i></button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="sidebar__widget mb-50 ">
                        <div className="sidebar__widget-title mb-50">
                            <h3>Popular Tags</h3>
                        </div>
                        <div className="sidebar__widget-content">
                            <div className="tags">
                                <Link to="/blogDetails">The Saas</Link>
                                <Link to="/blogDetails">Pix Saas Blog</Link>
                                <Link to="/blogDetails">Landing</Link>
                                <Link to="/blogDetails">UI/UX Design</Link>
                                <Link to="/blogDetails">Branding</Link>
                                <Link to="/blogDetails">Animation</Link>
                                <Link to="/blogDetails">Design</Link>
                                <Link to="/blogDetails">Ideas</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogLeftSideBar;
